import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as XLSX from "xlsx"
  import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import minnotra_logo from "../../../Assets/Images/logo2.png";


function ExportToExcel({report,meters, parameters,filename,size,disable,excelFromDate,excelToDate}) {

  console.log(filename) 
  
    const [excelImage, setExcelImage] = useState(null);
   const loggedIn = useSelector((state) => state.user);
  // console.log(loggedIn)
  useEffect(()=>{

    setExcelImage(loggedIn?.images?.excelImage?`data:image/png;base64,${loggedIn?.images?.excelImage}`:null);
  },[loggedIn])
const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;
 
  const finalReport = []
  report?.filter(re => {
    const Date = re.date
    const data = {Date}
    meters?.forEach(meter => {
      if(re[meter]){
        data[meter] = re[meter]
      }
    })
    finalReport.push(data)
  })
  // const exportTo = () => {
  //   if (report && report.length > 0) {
  //     const wb = XLSX.utils.book_new();
  //     const ws = XLSX.utils.json_to_sheet(finalReport);
  
  //     const now = new Date();
  //     const timestamp = now
  //       .toLocaleString("en-US", {
  //         year: "numeric",
  //         month: "2-digit",
  //         day: "2-digit",
  //         hour: "2-digit",
  //         minute: "2-digit",
  //         second: "2-digit",
  //         hour12: false, // Use 24-hour format
  //       })
  //       .replace(/[/,: ]/g, "-");
  
  //     const filename = `raw_data_report_${timestamp}.xlsx`;
  
  //     XLSX.utils.book_append_sheet(wb, ws, "raw_data_report");
  //     XLSX.writeFile(wb, filename);
  //   }
  // };




const getImageBufferFromUrl = async (url) => {
  const response = await fetch(url);
  return await response.arrayBuffer();
};

console.log(report)
const exportTo = async (excelFromDate, excelToDate) => {
  if (report && report.length > 0) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("raw_data_report");

    const columnKeys = Object.keys(finalReport[0]);

    //   Step 1: Merge cells A1:B2 for the logo
    worksheet.mergeCells("A1:B2");

    //   Step 2: Add logo
    const logoUrl = excelImage? excelImage:minnotra_logo;
    const imageBuffer = await getImageBufferFromUrl(logoUrl);
    const imageId = workbook.addImage({
      buffer: imageBuffer,
      extension: "png",
    });

    worksheet.addImage(imageId, {
      tl: { col: 0.2, row: 0.1 },
      ext: { width: 100, height: 38 },
    });

    //   Step 3: Add Title "RawData Report"
    worksheet.mergeCells("A3:D3");
    const titleCell = worksheet.getCell("A3");
    titleCell.value = "RawData Report";
    titleCell.font = { bold: true, size: 14 };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };

    //   Step 4: Add From & To Date below title
    worksheet.mergeCells("A4:D4");
    const dateCell = worksheet.getCell("A4");
    dateCell.value = `From: ${excelFromDate}   To: ${excelToDate}`;
    dateCell.font = { bold: true, size: 11 };
    dateCell.alignment = { horizontal: "left", vertical: "middle" };

    //   Step 5: Add headers (Row 6 now, since logo+title+dates occupy top rows)
    const headerRowIndex = 6;
    worksheet.getRow(headerRowIndex).values = columnKeys;

    const headerRow = worksheet.getRow(headerRowIndex);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF00B050" }, // Green
      };
      cell.font = {
        bold: true,
        color: { argb: "FFFFFFFF" }, // White
      };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    //   Step 6: Add data rows (starting from row 7)
    finalReport.forEach((item) => {
      const rowData = columnKeys.map((key) => item[key]);
      const row = worksheet.addRow(rowData);

      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
    });

    //   Step 7: Auto-fit column widths
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const colLength = cell.value ? cell.value.toString().length : 0;
        if (colLength > maxLength) {
          maxLength = colLength;
        }
      });
      column.width = maxLength < 10 ? 12 : maxLength + 2;
    });

    //   Step 8: Save file with timestamp
    const now = new Date();
    const timestamp = now
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(/[/,: ]/g, "-");

    const fileName = `raw_data_report_${timestamp}.xlsx`;
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), fileName);
  } else {
    handleNotification("No data available to export", "error");
  }
};




  return (
    <div className={` ${isdarkMode ? 'exportbtn' : 'whitemode'}`}>
    <Button size={size?size:'small'} type='primary' variant="contained" defaultColor='green' onClick={()=>exportTo(excelFromDate,excelToDate)}
    disabled={disable? disable:false}>
        Export to Excel
      </Button>
    </div>
  );
}

export default ExportToExcel;